import {Badge, Box, Collapse, Table, TableBody, TableCell, TableRow, useTheme} from "@mui/material";
import {withStyles} from "@mui/styles"
import React, {useState} from 'react';
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {green, yellow} from "@mui/material/colors";
import PauseIcon from "@mui/icons-material/Pause";
import {useGroup} from "../contexts/GroupContext";
import {parseFullTimestamp} from "./Utils";
import CancelButton from "./CancelButton";
// import {makeStyles} from "@material-ui/core/styles";

function Row(props) {
    const {sendUserInput, isV2} = useGroup()
    const {name, data, connected} = props;
    const [open, setOpen] = useState(false);
    const handlePlay = (event, gid, listener, predicate) => {
        event.stopPropagation()
        if (!(predicate === "None")) {
            sendUserInput("resume", listener)
        }
    }

    const handlePause = (event, gid, listener, predicate) => {
        event.stopPropagation()
        if (!(predicate === "None")) {
            sendUserInput("stop", listener)
        }
    }

    const handleCancel = (gid, listener, predicate) => {
        if (!(predicate === "None")) {
            sendUserInput(`cancel task with gid ${gid}`, listener)
        }
    }

    const handleCancelGoal = (index, listener) => {
        if (isV2) {
            //index here is really gid
            sendUserInput(`remove goal from queue ${index}`, listener)
        } else {
            sendUserInput(`remove goal from queue at position ${index}`, listener)
        }
    }

    const StyledTableRow = withStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.custom.backgroundThree,
            '& td': {
                border: "0 !important"
            },
            '& th': {
                borderBottom: "1px solid " + theme.palette.custom.goalSubDivider + " !important"
            },
            '&:last-child th': {
                borderBottom: "1px solid " + theme.palette.custom.goalDivider + " !important"
            },
        },
    }))(TableRow);

    const StyledIconButton = withStyles((theme) => ({
        root: {
            '& svg': {
                color: theme.palette.custom.accent,
                background: theme.palette.custom.button,
                borderRadius:"80%"
            }
        },
    }))(IconButton);

   let onlineStatusSymbol = connected === "online" ? <CheckCircleIcon style={{ color: "green" }}/> :<CancelIcon style={{ color: "red" }} />

   if (isV2) {
        return (
            <React.Fragment>
                <TableRow onClick={() => {
                    setOpen(!open)
                }}>
                    <TableCell width={40}>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon  color={'alt'}/> :
                                <Badge color="primary" badgeContent={data.queue.length}>
                                    <KeyboardArrowDownIcon  color={'alt'}/>
                                </Badge>}
                        </IconButton>
                    </TableCell>
                    <TableCell width={80}>{name}</TableCell>
                    <TableCell width={70}>{onlineStatusSymbol}</TableCell>
                    <TableCell>{data.active.predicate}</TableCell>
                    <TableCell width={100}>{data.active.status}</TableCell>
                    <TableCell width={200}>{parseFullTimestamp(data.active.gid)}</TableCell>
                    <TableCell width={120}>
                        <Box display="flex" flexGrow={1} justifyContent="flex-end">
                            <StyledIconButton onClick={(event) => handlePlay(event, data.active.gid, name, data.active.predicate)}>
                                <PlayArrowIcon fontSize="medium"/>
                            </StyledIconButton>
                            <StyledIconButton onClick={(event) => handlePause(event, data.active.gid, name, data.active.predicate)}>
                                <PauseIcon fontSize="medium"/>
                            </StyledIconButton>
                            <CancelButton fontSize="medium" goal={data.active.predicate} onConfirm={() => handleCancel(data.active.gid, name, data.active.predicate)}/>
                        </Box>
                    </TableCell>
                </TableRow>
                <StyledTableRow>
                    <TableCell padding="none" colSpan={7}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box>
                                <Table size="small">
                                    <TableBody >
                                        {data.queue.map((entry, index) => (
                                            <StyledTableRow key={entry.gid} >
                                                <TableCell component="th" width={40}/>
                                                <TableCell component="th" width={80}/>
                                                <TableCell component="th" width={70}/>
                                                <TableCell component="th">
                                                        {entry.predicate}
                                                </TableCell>
                                                <TableCell component="th" width={100}>{entry.status}</TableCell>
                                                <TableCell component="th" width={200}>{parseFullTimestamp(entry.gid)}</TableCell>
                                                <TableCell component="th" width={120} align="right">
                                                    <CancelButton fontSize="medium" goal={entry.predicate} onConfirm={() => handleCancelGoal(entry.gid, name)}/>
                                                </TableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </StyledTableRow>
            </React.Fragment>
        );
   }
   else {
       //TODO: make minWidth for table and keep cells aligned at all times
        return (
            <React.Fragment>
                <TableRow onClick={() => {
                    setOpen(!open)
                }}>
                    <TableCell width={40}>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon  color={'alt'}/> :
                                <Badge color="primary" badgeContent={data.queue.length}>
                                    <KeyboardArrowDownIcon  color={'alt'}/>
                                </Badge>}
                        </IconButton>
                    </TableCell>
                    <TableCell width={80}>{name}</TableCell>
                    <TableCell width={70}>{onlineStatusSymbol}</TableCell>
                    <TableCell>{data.active.predicate}</TableCell>
                    <TableCell width={100}>{data.active.status}</TableCell>
                    <TableCell width={200}>{parseFullTimestamp(data.active.gid)}</TableCell>
                    <TableCell width={120}>
                        <Box display="flex" flexGrow={1} justifyContent="flex-end">
                            <StyledIconButton onClick={(event) => handlePlay(event, data.active.gid, name, data.active.predicate)}>
                                <PlayArrowIcon fontSize="medium"/>
                            </StyledIconButton>
                            <StyledIconButton onClick={(event) => handlePause(event, data.active.gid, name, data.active.predicate)}>
                                <PauseIcon fontSize="medium"/>
                            </StyledIconButton>
                            <CancelButton fontSize="medium" goal={data.active.predicate} onConfirm={() => handleCancel(data.active.gid, name, data.active.predicate)}/>
                        </Box>
                    </TableCell>
                </TableRow>
                <StyledTableRow>
                    <TableCell padding="none" colSpan={7}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box>
                                <Table size="small">
                                    <TableBody >
                                        {data.queue.map((entry, index) => (
                                            <StyledTableRow key={entry.gid} >
                                                <TableCell component="th" width={40}/>
                                                <TableCell component="th" width={80}/>
                                                <TableCell component="th" width={70}/>
                                                <TableCell component="th">
                                                        {entry.predicate}
                                                </TableCell>
                                                <TableCell component="th" width={100}>{entry.status}</TableCell>
                                                <TableCell component="th" width={200}>{parseFullTimestamp(entry.gid)}</TableCell>
                                                <TableCell component="th" width={120} align="right">
                                                    <CancelButton fontSize="medium" goal={entry.predicate} onConfirm={() => handleCancelGoal(index, name)}/>
                                                </TableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </StyledTableRow>
            </React.Fragment>
        );
    }
}

export default Row
